module.exports = __webpack_public_path__ + "3934300233a7d2b026c1105549c60127.png";